export default "__VITE_ASSET__41a09987__"